import PageLayout from "@/components/feature/PageLayout";
import { useSeo } from "@/hooks/useSeo";
import HomeHero from "./components/HomeHero";
import CategoryQuickEntry from "./components/CategoryQuickEntry";
import LatestMoviesSection from "./components/LatestMoviesSection";
import TopRatedSection from "./components/TopRatedSection";
import CinemaPreview from "./components/CinemaPreview";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useSeo({
    title: "最新电影-高清电影资讯与上映动态平台",
    description:
      "最新电影为您提供最新上映电影资讯、电影评分介绍及影院上映动态，覆盖多种类型电影，轻松了解最新影片信息。",
    keywords: "最新电影,电影资讯,电影上映,电影推荐,电影评分,影视动态,电影预告",
    canonicalPath: "/",
  });

  return (
    <PageLayout>
      <HomeHero />
      <CategoryQuickEntry />
      <LatestMoviesSection />
      <div className="w-full bg-background-100">
        <TopRatedSection />
      </div>
      <CinemaPreview />
      <SiteIntro />
    </PageLayout>
  );
}